import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Business } from 'app/model/business';
import { BusinessType } from 'app/model/businessTypes';
import { BusinessTypeService } from 'app/services/business-types.service';

@Component({
    selector: 'app-new-business-dialog',
    templateUrl: './new-business-dialog.component.html',
    encapsulation: ViewEncapsulation.None,
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule
    ],
    standalone: true
})
export class NewBusinessDialogComponent implements OnInit {
    businessTypes: BusinessType[] = [];

    constructor(
        public dialogRef: MatDialogRef<NewBusinessDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { businesses: Business[] },
        private _businessTypeService: BusinessTypeService
    ) { }

    async ngOnInit() {
        await this.getAllBusinessTypes();
    }

    async getAllBusinessTypes() {
        const token = localStorage.getItem('SessionToken') ?? '';
        try {
            const res = await this._businessTypeService.getListBusinessTypes(
                0,
                1000,
                '',
                token
            );
            if (res?.recordList) {
                this.businessTypes = res.recordList;
            }
        } catch (error) {
            console.error('Error fetching business types', error);
        }
    }

    getBusinessTypeName(ids: any): string {
        if (!ids) return '';
        
        // Convert to string and split by comma to handle multiple IDs (e.g. "1,2") or single ID (e.g. 1)
        const idList = ids.toString().split(',').map((id: string) => parseInt(id.trim())).filter((id: number) => !isNaN(id));
        
        const names = idList.map((id: number) => {
            const type = this.businessTypes.find(t => t.id === id);
            return type ? type.name : '';
        }).filter((name: string) => name !== '');

        return names.join(', ');
    }

    close(): void {
        this.dialogRef.close();
    }

    viewBusiness(businessId: number): void {
        this.dialogRef.close(businessId);
    }
}
